import './App.css';
import Home from './components/Home/Home';
import Navbar1 from './components/Home/Navbar/Navbar1';

function App() {
  return (
    <div>
          <Navbar1></Navbar1>
          <Home></Home>
    </div>
  );
}

export default App;
